<template>
  <div>
    <F10Fund v-if="type === '1'" />
    <F10Stock v-if="type === '0'" />
    <Disclaimer />
  </div>
</template>

<script>
import F10Fund from './F10Fund.vue'
import F10Stock from './F10Stock.vue'
import Disclaimer from '@/components/common/Disclaimer.vue'
export default {
  components: { F10Fund, F10Stock, Disclaimer },
  data() {
    return {
      type: this.$route.query.isEtf ?? '0'
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    // this.getSecurityType()
  },
  methods: {
    async getSecurityType() {
      const res = await this.$post(this.$api.f10[this.market] + '/extend_all', {
        symbols: [this.symbol]
      })
      // console.log('res', res)
      const { isEtf } = res.data?.[0] ?? {}
      this.type = isEtf
    }
  }
}
</script>

<style lang="scss" scoped></style>
